(function () {
  function qs(r, s){ return (r||document).querySelector(s); }
  function qsa(r, s){ return Array.from((r||document).querySelectorAll(s)); }

  function findHero(){
    return qsa(
      document,
      '#MainContent [class*="slideshow"], #MainContent [class*="hero"], #MainContent [class*="banner"]'
    )[0];
  }

  function getSlides(hero){
    const sels = [
      '.swiper-slide',
      '.slideshow__slide',
      '.slide',
      '[role="group"]'
    ];
    for (const sel of sels){
      const slides = qsa(hero, sel);
      if (slides.length > 1) return slides;
    }
    return [];
  }

  function getActiveIndex(slides){
    let idx = slides.findIndex(s =>
      s.classList.contains('is-selected') ||
      s.classList.contains('swiper-slide-active') ||
      s.getAttribute('aria-hidden') === 'false'
    );
    return idx >= 0 ? idx : 0;
  }

  function init(){
    const hero = findHero();
    if (!hero || qs(hero, '.hero-dots')) return;

    const slides = getSlides(hero);
    if (slides.length < 2) return;

    hero.classList.add('hero-dots-host');

    const dotsWrap = document.createElement('div');
    dotsWrap.className = 'hero-dots';

    const dots = slides.map((_, i) => {
      const b = document.createElement('button');
      b.className = 'hero-dots__dot';
      b.type = 'button';
      b.onclick = () => slides[i].scrollIntoView({behavior:'smooth',inline:'start'});
      dotsWrap.appendChild(b);
      return b;
    });

    hero.appendChild(dotsWrap);

    function update(){
      const active = getActiveIndex(slides);
      dots.forEach((d,i)=>d.classList.toggle('is-active', i === active));
    }

    update();

    // observar cambios de clase / atributos (cuando cambia el slide)
    const mo = new MutationObserver(update);
    slides.forEach(s => {
      mo.observe(s, { attributes: true, attributeFilter: ['class','aria-hidden'] });
    });
  }

  document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('shopify:section:load', init);
})();
